import { CREATE_TAG } from '../../constants';

const initialState = {
  data: {},
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case CREATE_TAG.LOAD:
      return {
        ...state,
        loading: true,
      };
    case CREATE_TAG.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case CREATE_TAG.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
